import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { PropMixAdminClient } from "../../repsaApi";

const client = new PropMixAdminClient(app_uri, axiosClient());

export default client;
